<template>
  <div>
    <FieldTitle :model="model" />
    <!--Readonly mode-->
    <!-- DESKTOP/TABLE (readonly) -->
    <div v-if="readOnly" class="hidden md:block pb-10">
      <div class="rounded-lg overflow-hidden border border-gray-300">
        <!-- header -->
        <div class="grid grid-cols-[170px_1fr_1fr] h-11 text-lg text-gray-700 font-medium">
          <div class="px-4 py-2 bg-lightestblue-100"></div>
          <div class="px-4 py-2 bg-lightestblue-100 border-l border-gray-300 flex items-center gap-2">
            <font-awesome-icon class="text-lg text-green-200" icon="check" />
            <span class="text-lg leading-tight font-medium">Fordeler</span>
          </div>
          <div class="px-4 py-2 bg-lightestblue-100 border-l border-gray-300 flex items-center gap-2">
            <font-awesome-icon class="text-lg text-red-200" icon="times" />
            <span class="textlg -leading-tight font-medium">Ulemper</span>
          </div>
        </div>
        <!-- rows -->
        <div v-for="(row, index) in table.rows" :key="$uuid(index)"
          class="grid grid-cols-[170px_1fr_1fr] divide-gray-300 border-t border-gray-300 bg-white text-lg text-gray-700">
          <ProsConsRow :row="row" :pageId="pageId" :readOnly="readOnly" :preview="preview" />
        </div>
      </div>
    </div>

    <!-- MOBILE/CARDS (readonly) -->
    <div v-if="readOnly" class="md:hidden space-y-3">
      <ProsConsCard v-for="(row, index) in table.rows" :key="$uuid('m' + index)" :row="row" :readOnly="true" />
    </div>

    <!-- Edit mode -->
    <div v-if="!readOnly" class=" pt-4 pb-10 w-full pr-0">

      <!-- DESKTOP/TABLE (edit mode) -->
      <div class="flex">
        <div class="hidden md:block rounded-lg overflow-hidden border w-full border-gray-300">
          <!-- header -->
          <div class="grid grid-cols-[170px_1fr_1fr] h-11 text-lg text-gray-700 font-medium">
            <div class="px-4 py-2 bg-lightestblue-100"></div>
            <div class="px-4 py-2 bg-lightestblue-100 border-l border-gray-300 flex items-center gap-2">
              <font-awesome-icon class="text-lg text-green-200" icon="check" />
              <span class="text-lg leading-tight font-medium">Fordeler</span>
            </div>
            <div class="px-4 py-2 bg-lightestblue-100 border-l border-gray-300 flex items-center gap-2">
              <font-awesome-icon class="text-lg text-red-200" icon="times" />
              <span class="text-lg leading-tight font-medium">Ulemper</span>
            </div>
          </div>
          <!-- rows -->
          <div v-for="(row, index) in table.rows" :key="$uuid('e' + index)"
            class="grid grid-cols-[170px_1fr_1fr] divide-gray-300 border-t border-gray-300 bg-white text-lg text-gray-700">
            <ProsConsRow :row="row" :pageId="pageId" />
          </div>
        </div>
        <!--Comments-->
        <div class="hidden pr-0 mb-4 xl:block lg:pl-4">
          <CommentPane v-if="!model.deactivateComments" :model="model.comments" :contentGuid="model.contentGuid"
            :pageId="pageId" :fieldTitle="model.title" />
        </div>
      </div>

      <!-- MOBILE CARDS (edit mode) -->
      <div class="md:hidden w-full space-y-3">
        <ProsConsCard v-for="(row, index) in table.rows" :key="$uuid('em' + index)" :row="row" :readOnly="false"
          :pageId="pageId" />
      </div>

    </div>
  </div>
</template>

<script>
import CommentPane from '@/views/components/schema/CommentPane.vue';
import ProsConsRow from '@/views/components/schema/proscons/ProsConsRow.vue';
import ProsConsCard from '@/views/components/schema/proscons/ProsConsCard.vue';
import FieldTitle from "@/views/components/schema/common/FieldTitle.vue";

export default {
  props: { model: Object, pageId: String, readOnly: Boolean, preview: Boolean },
  data() {
    return { table: this.model.properties.table == null ? [] : this.model.properties.table };
  },
  components: {FieldTitle, ProsConsRow, ProsConsCard, CommentPane },
};
</script>
